<template>
    <div>
        <Hero bg="/static/img/Internships/internships_bckg_pic.jpg" title="Internships" theme="green">
            <p class="paragraph">Want some XP in game development? You've come to the right place! As an intern you’ll
                make important contributions to our projects while being mentored by experienced professionals.
                <br><br>If you're interested, take a look at our available internships and send us your application. If
                you can’t see a suitable position send us a message anyway and we’ll see what we can do.</p>

            <BasicButton class="content__link" tag="router-link" to="/positions?departments=12#jobs" type="black">View
                Job
                Openings
            </BasicButton>
        </Hero>
    </div>
</template>

<script>
    import Hero from '../components/common/HerroConstructor'
    import BasicButton from '../components/BasicButton'
    import ApplicationForm from "../components/applicationPageComponents/ApplicationForm";
    import JobTiles from "../components/JobTiles";

    export default {
        name: 'internships',
        components: {
            JobTiles,
            ApplicationForm,
            Hero,
            BasicButton
        },
        metaInfo() {
            return {
                title: 'Internships',
                htmlAttrs: {
                    lang: 'en',
                    metaInfo: {
                        meta: [
                            {charset: 'utf-8'},
                            {name: 'og:title', content: 'Intenships'},
                            {name: 'description', content: 'Bohemia Interactive Internship page'},

                        ]
                    }
                }

            }
        }

    }
</script>

<style lang="scss">
    #navigation {
        background-color: rgba(236, 236, 236, .2) !important;
    }

    .section-resting {
        background: url('/static/img/backgrounds/parallax_resting_bckg.jpg') center no-repeat;
        background-size: cover;
        height: 1080px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/Internships.vue